/**
 * Helper com métodos estáticos para converter links de vídeo em URLs de embed.
 */
export class VideoEmbedHelper {
  private static readonly YOUTUBE_ID = /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:embed|shorts|live)\/|[?&]v=)([\w-]{6,})/;
  private static readonly DRIVE_ID = /drive\.google\.com\/(?:file\/d\/|open\?(?:.*&)?id=|uc\?(?:.*&)?id=)([\w-]+)/;

  /**
   * Retorna a URL de embed para links do YouTube ou de vídeos compartilhados no Google Drive.
   * Retorna string vazia quando o link não pertence a nenhum provedor suportado.
   */
  static getEmbedUrl(url?: string): string {
    if (!url) return '';

    const youtubeId = url.match(this.YOUTUBE_ID)?.[1];
    if (youtubeId) return `https://www.youtube.com/embed/${youtubeId}`;

    const driveId = url.match(this.DRIVE_ID)?.[1];
    if (driveId) return `https://drive.google.com/file/d/${driveId}/preview`;

    return '';
  }
}
